import type { KeyboardEvent } from 'react';

export interface ComposerKeyEvent {
  readonly key: string;
  readonly ctrlKey: boolean;
  readonly metaKey: boolean;
}

/* Cmd compte autant que Ctrl : sur macOS il n'existe pas de Ctrl sous les
   doigts, et n'accepter que Ctrl priverait ces utilisateurs de tout raccourci
   d'envoi — le bouton resterait leur seul chemin. */
export function isComposerSubmit(event: ComposerKeyEvent): boolean {
  return event.key === 'Enter' && (event.ctrlKey || event.metaKey);
}

/* Dans un parcours, Entrée seule envoie. Ce n'est pas une incohérence oubliée :
   les réponses mesurées y font 4 à 128 caractères, médiane une dizaine — « 2h30 »,
   « 12 », « b ». Exiger deux touches pour envoyer quatre caractères coûte plus
   qu'il ne protège, là où un chat de rédaction a besoin du retour à la ligne. */
export function isParcoursSubmit(event: ComposerKeyEvent & { readonly shiftKey: boolean }): boolean {
  return event.key === 'Enter' && !event.shiftKey;
}

export function composerKeyHandler(
  submit: () => void,
  isSubmit: (event: ComposerKeyEvent & { readonly shiftKey: boolean }) => boolean = isComposerSubmit,
): (event: KeyboardEvent<HTMLTextAreaElement>) => void {
  return (event) => {
    if (!isSubmit(event)) return;
    event.preventDefault();
    submit();
  };
}
